const print_at_home = 2;
const physical_ticket = 3;
const mobile = 8;
const mobile_tranfer = 10;

export {print_at_home, physical_ticket, mobile, mobile_tranfer};
